import { siteData } from "../data/mock";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  return (
   <a
  href={siteData.brand.whatsappLink}
  target="_blank"
  rel="noopener noreferrer"
  className="fixed bottom-6 right-6 z-50 flex items-center gap-2 p-4 rounded-full shadow-2xl transition-all duration-450 hover:scale-110 animate-bounce"
  style={{ backgroundColor: '#25D366', color: '#FFFFFF' }}
  aria-label="Agendar consulta pelo WhatsApp"
>
  <MessageCircle size={24} />
</a>

  );
};
